/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Sales_Return_DecreaseInputs */

const vi_sales_return_decrease = /** @type {(inputs: Sales_Return_DecreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giảm ${i?.label}`)
};

/**

* @param {Sales_Return_DecreaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_decrease = /** @type {((inputs: Sales_Return_DecreaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_DecreaseInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_decrease(inputs)
});